module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/iphone5_splash-55affdfc67cac9f9b9622d9a89c50e3b.png";